import { CloseOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Carousel } from 'antd';

import { useData } from '../../../shared/hooks/use-data';
import {
    StyledButton,
    StyledCard,
    StyledCardContainer,
    StyledCarouselContainer,
    StyledHeader,
    StyledImage,
    StyledInfoContainer,
    StyledParagraph,
} from './custom-balloon.style';
import { CustomArrow } from '../../../shared/components/custom-arrows/custom-arrows';
import { baseImagesUrl } from '../../../app';

type CustomBallonProps = {
    position: { x: number, y: number };
    isBottom: boolean;
}

export const CustomBalloon = ({ position, isBottom }: CustomBallonProps) => {
    const { selectedDataItem, setSelectedDataItem, setDetailsModalInfo } = useData();

    const closeBalloon = (e: React.MouseEvent<HTMLElement>): void => {
        e.stopPropagation();

        setSelectedDataItem(null);
    }

    return (
        <StyledCardContainer
            $x={position.x}
            $y={position.y}
            $isBottom={isBottom}
        >
            <StyledCard
                size="small"
                extra={
                    <Button
                        type="text"
                        icon={<CloseOutlined />}
                        shape='circle'
                        onClick={closeBalloon}
                    />
                }
            >
                <StyledCarouselContainer
                    className='clear-default-arrows-in-carousel'
                    onClick={(e) => e.stopPropagation()}
                >
                    <Carousel
                        arrows
                        autoplay
                        prevArrow={<CustomArrow size={1} icon={<LeftOutlined />} />}
                        nextArrow={<CustomArrow size={1} icon={<RightOutlined />} />}
                    >
                        {selectedDataItem.images?.map((url) => (
                            <StyledImage
                                src={`${baseImagesUrl}/${url}`}
                                alt="image"
                                preview={false}
                            />
                        ))}
                    </Carousel>
                </StyledCarouselContainer>

                <StyledInfoContainer>
                    <StyledHeader>{selectedDataItem.name}</StyledHeader>
                    <StyledParagraph>{selectedDataItem.address}</StyledParagraph>
                </StyledInfoContainer>

                <StyledButton onClick={() => setDetailsModalInfo(selectedDataItem)}>Подробнее</StyledButton>
            </StyledCard>
        </StyledCardContainer>
    )
}


